import { Component, OnDestroy, OnInit } from '@angular/core';
import * as fromStore from '../../store';
import { Subject, Subscription } from 'rxjs';
import {select, Store} from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { MessageService, TreeNode, SortEvent } from 'primeng/api';
import {filter, map, switchMap, takeUntil} from 'rxjs/operators';
import {CryptoService} from '../../services/crypto.service';

@Component({
  standalone: false,
  selector: 'app-change-history',
  templateUrl: './change-history.component.html',
  styleUrls: ['./change-history.component.css']
})
export class ChangeHistoryComponent implements OnInit, OnDestroy {
  dcode: string;
  changeInfoName: string;
  changeInfoNewLevel: string;
  changeInfoCreateTime: Date;
  changeInfoNewExpiredDate: Date;
  changeHistory: any;
  private changeHistoryList$: Subscription;
  private componentDestroyed = new Subject();
  localTimeZone = new Date().getTimezoneOffset() / 60;

  licenseData: any;
  statusAvailable: number;
  statusUsing: number;
  statusExpired: number;
  deviceTable_cols: any[] = [
    { field: 'AddDate', header: 'Add Date', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'License', header: 'License', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'Level', header: 'Level', width: '100', class: 'col-nowrap', disabled: false },
    { field: 'Period', header: 'Period', width: '100', class: 'col-nowrap', disabled: false },
    { field: 'StartedDate', header: 'Estimated Start Date', width: '180', class: 'col-nowrap', disabled: false },
  ];
  constructor(
    private store: Store<fromStore.State>,
    private route: ActivatedRoute,
    private cryptoService: CryptoService) {
    this.dcode = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('dcode'));

    this.store.pipe(select(fromStore.DevicesFiltered),
      switchMap((devices) => devices),
      filter((item) => item.dcode.toString() === this.dcode),
      takeUntil(this.componentDestroyed)
    ).subscribe(res => {
      this.changeInfoName = res.name;
      this.changeInfoNewLevel = 'Level ' + res.level;
      this.changeInfoCreateTime = res.connectedDate;
      this.changeInfoNewExpiredDate = res.expireDate;
    });
    this.changeHistoryList$ = this.store.select(fromStore.getChangeInfo, this.dcode).subscribe(res => {
      this.changeHistory = Array.isArray(res) ? res.map((e) => ({ ...e })) : res;
    });
  }

  ngOnInit() {
    this.UI();
    this.licenseData = [
      {
        AddDate: '2018/01/01',
        License: 'HT2AH5UUJQ',
        Level: 'Level 3',
        Period: '1 Year',
        Status: 'Expired',
        StartedDate: '2008/1/1',
        ExpiredDate: '2011/1/1'
      },
      {
        AddDate: '2018/01/01',
        License: '4M3GEOEQ9E',
        Level: 'Level 3',
        Period: '2 Years',
        Status: 'Expired',
        StartedDate: '2008/1/1',
        ExpiredDate: '2011/1/1'
      },
      {
        AddDate: '2018/01/01',
        License: '15JZ653WUJ',
        Level: 'Level 3',
        Period: '1 Year',
        Status: 'Expired',
        StartedDate: '2008/1/1',
        ExpiredDate: '2011/1/1'
      },
      {
        AddDate: '2018/01/01',
        License: 'U8RU4JVV30',
        Level: 'Level 3',
        Period: '2 Years',
        Status: 'Expired',
        StartedDate: '2008/1/1',
        ExpiredDate: '2010/1/1'
      },
      {
        AddDate: '2018/01/01',
        License: '15JZ553WUJ',
        Level: 'Level 3',
        Period: '1 Year',
        Status: 'Expired',
        StartedDate: '2008/1/1',
        ExpiredDate: '2011/1/1'
      },
      {
        AddDate: '2018/01/01',
        License: 'U8RU6JVV30',
        Level: 'Level 3',
        Period: '2 Years',
        Status: 'Expired',
        StartedDate: '2008/1/1',
        ExpiredDate: '2010/1/1'
      }
    ];
  }

  customSort(event: SortEvent) {
    // NgRx 9 不可變性: 創建數組副本再排序，並寫回元件資料來源
    const sortedData = [...event.data].sort((data1, data2) => {
      const value1 = data1[event.field];
      const value2 = data2[event.field];
      let result = null;
      if (value1 == null && value2 != null) {
        result = -1;
      } else if (value1 != null && value2 == null) {
        result = 1;
      } else if (value1 == null && value2 == null) {
        result = 0;
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      } else {
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
      }
      return (event.order * result);
    });
    event.data = sortedData;
    this.licenseData = sortedData;
  }

  ngOnDestroy(): void {
    this.changeHistoryList$.unsubscribe();
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    // body.classList.remove('layout-toggle');
    body.classList.remove('mobile-toggle');
  }
}
